{
  "meta": {
    "employeeProfile": "Профиль сотрудника",
    "employeeInfo": "Информация о сотруднике",
    "employeeCreate": "Создание сотрудника",
    "employeeEdit": "Редактирование сотрудника",
    "employeeList": "Сотрудники"
  },
  "employee": "Сотрудник",
  "employeers": "Сотрудники",
  "new-employee": "Новый сотрудник",
  "active": "Активный",
  "deleteEmployee": "Удалить сотрудника",
  "inactive": "Неактивный",
  "create-employee": "Создать сотрудника",
  "edit-employee": "Редактирование сотрудника",
  "relevantCandidates": "Рекомендованные кандидаты",
  "successDeleted": "успешно удален",
  "employeeDeleted": "Сотрудник удален",
  "filters": "Фильтры",
  "failDelete": "Не удалось удалить сотрудника",
  "deleteConfirmRectutier": "Подтвердите удаление пользователя, при этом все вакансии данного пользователя будут переданы менеджеру компании.",
  "surname": "Фамилия",
  "name": "Имя",
  "phone": "Телефон",
  "phoneNumber": "Номер телефона",
  "role": "Роль",
  "activity": "Активность",
  "vacancy": "Вакансии",
  "breadcrumbs": {
    "new": "Новый сотрудник"
  },
  "form": {
    "select": "Выберите",
    "surname": {
      "title": "Фамилия",
      "description": "Фамилия сотрудника",
      "placeholder": "Введите фамилию"
    },
    "name": {
      "title": "Имя",
      "description": "Имя сотрудника",
      "placeholder": "Введите имя"
    },
    "email": {
      "title": "Email",
      "description": "Контактный Email",
      "placeholder": "example@test.ru"
    },
    "phone": {
      "title": "Контактный телефон",
      "description": "Номер телефона для связи",
      "placeholder": "+"
    },
    "group": {
      "title": "Группа",
      "description": "Ролевая группа",
      "placeholder": "Выберите ролевую группу"
    },
    "company": {
      "title": "Компания",
      "description": "Компания, в которой работает сотрудник"
    },
    "password": {
      "title": "Пароль",
      "description": "Пароль для входа в систему",
      "placeholder": "Введите пароль"
    },
    "confirmPassword": {
      "title": "Подтверждение пароля",
      "description": "Подтверждение пароля",
      "placeholder": "Введите пароль"
    },
    "personalData": "Личные данные"
  },
  "error": {
    "create": "Ошибка при создании сотрудника",
    "update": "Ошибка при обновлении сотрудника"
  }
}
